import { n as l } from "./platform-components-assets/nebula_tokens-es.js";
import h from "./DomHelper.js";
import m from "./SelectionHelper.js";
const r = [
  {
    gender: "male",
    language: {
      codes: [
        "ar",
        "ar-ae"
      ],
      display_name: "العربية",
      name: "Arabic",
      rtl: !0
    },
    vendor: "Nuance",
    voice_id: "Tarik"
  },
  {
    gender: "female",
    language: {
      codes: [
        "zh",
        "zh-cn"
      ],
      display_name: "中文(简体)",
      name: "Chinese (Mandarin - Simplified)"
    },
    vendor: "Nuance",
    voice_id: "Tian-Tian"
  },
  {
    gender: "female",
    language: {
      codes: [
        "zh-tw"
      ],
      display_name: "中文(台灣)",
      name: "Chinese (Mandarin - Traditional)"
    },
    vendor: "Nuance",
    voice_id: "Mei-Jia"
  },
  {
    gender: "female",
    language: {
      codes: [
        "cs",
        "cs-cz"
      ],
      display_name: "Čeština",
      name: "Czech"
    },
    vendor: "Nuance",
    voice_id: "Zuzana"
  },
  {
    gender: "female",
    language: {
      codes: [
        "nl",
        "nl-nl"
      ],
      display_name: "Nederlands",
      name: "Dutch (Netherlands)"
    },
    vendor: "Nuance",
    voice_id: "Claire"
  },
  {
    gender: "female",
    language: {
      codes: [
        "en-au"
      ],
      display_name: "English (Australia)",
      name: "English (Australia)"
    },
    vendor: "Nuance",
    voice_id: "Karen"
  },
  {
    gender: "female",
    language: {
      codes: [
        "en-gb"
      ],
      display_name: "English (UK)",
      name: "English (UK)"
    },
    vendor: "Nuance",
    voice_id: "Serena"
  },
  {
    gender: "female",
    language: {
      codes: [
        "en",
        "en-us"
      ],
      display_name: "English (US)",
      name: "English (US)"
    },
    vendor: "Nuance",
    voice_id: "Ava"
  },
  {
    gender: "female",
    language: {
      codes: [
        "fi",
        "fi-fi"
      ],
      display_name: "Suomi",
      name: "Finnish"
    },
    vendor: "Nuance",
    voice_id: "Satu"
  },
  {
    gender: "female",
    language: {
      codes: [
        "fr",
        "fr-fr"
      ],
      display_name: "Français",
      name: "French"
    },
    vendor: "Nuance",
    voice_id: "Audrey"
  },
  {
    gender: "female",
    language: {
      codes: [
        "fr-ca"
      ],
      display_name: "Français (Canada)",
      name: "French (Canada)"
    },
    vendor: "Nuance",
    voice_id: "Amelie"
  },
  {
    gender: "female",
    language: {
      codes: [
        "de",
        "de-de"
      ],
      display_name: "Deutsch",
      name: "German"
    },
    vendor: "Nuance",
    voice_id: "Anna"
  },
  {
    gender: "female",
    language: {
      codes: [
        "el",
        "el-gr"
      ],
      display_name: "Ελληνικά",
      name: "Greek"
    },
    vendor: "Nuance",
    voice_id: "Melina"
  },
  {
    gender: "female",
    language: {
      codes: [
        "hi",
        "hi-in"
      ],
      display_name: "हिन्दी",
      name: "Hindi"
    },
    vendor: "Nuance",
    voice_id: "Lekha"
  },
  {
    gender: "female",
    language: {
      codes: [
        "hu",
        "hu-hu"
      ],
      display_name: "Magyar",
      name: "Hungarian"
    },
    vendor: "Nuance",
    voice_id: "Mariska"
  },
  {
    gender: "female",
    language: {
      codes: [
        "id",
        "id-id"
      ],
      display_name: "Bahasa Indonesia",
      name: "Indonesian"
    },
    vendor: "Nuance",
    voice_id: "Damayanti"
  },
  {
    gender: "female",
    language: {
      codes: [
        "it",
        "it-it"
      ],
      display_name: "Italiano",
      name: "Italian"
    },
    vendor: "Nuance",
    voice_id: "Alice"
  },
  {
    gender: "female",
    language: {
      codes: [
        "ja",
        "ja-jp"
      ],
      display_name: "日本語",
      name: "Japanese"
    },
    vendor: "Nuance",
    voice_id: "Sakura"
  },
  {
    gender: "female",
    language: {
      codes: [
        "ko",
        "ko-kr"
      ],
      display_name: "한국어",
      name: "Korean"
    },
    vendor: "Nuance",
    voice_id: "Sora"
  },
  {
    gender: "female",
    language: {
      codes: [
        "pl",
        "pl-pl"
      ],
      display_name: "Polski",
      name: "Polish"
    },
    vendor: "Nuance",
    voice_id: "Ewa"
  },
  {
    gender: "female",
    language: {
      codes: [
        "pt",
        "pt-pt"
      ],
      display_name: "Português",
      name: "Portuguese"
    },
    vendor: "Nuance",
    voice_id: "Joana"
  },
  {
    gender: "female",
    language: {
      codes: [
        "pt-br"
      ],
      display_name: "Português (Brasil)",
      name: "Portuguese (Brazilian)"
    },
    vendor: "Nuance",
    voice_id: "Luciana"
  },
  {
    gender: "female",
    language: {
      codes: [
        "ro",
        "ro-ro"
      ],
      display_name: "Română",
      name: "Romanian"
    },
    vendor: "Nuance",
    voice_id: "Ioana"
  },
  {
    gender: "female",
    language: {
      codes: [
        "ru",
        "ru-ru"
      ],
      display_name: "Русский",
      name: "Russian"
    },
    vendor: "Nuance",
    voice_id: "Milena"
  },
  {
    gender: "female",
    language: {
      codes: [
        "es-ar",
        "es-bo",
        "es-cl",
        "es-cr",
        "es-do",
        "es-ec",
        "es-gt",
        "es-hn",
        "es-mx",
        "es-ni",
        "es-pa",
        "es-py",
        "es-pe",
        "es-pr",
        "es-sv",
        "es-us",
        "es-uy",
        "es-vz"
      ],
      display_name: "Español",
      name: "Spanish (Mexican)"
    },
    vendor: "Nuance",
    voice_id: "Paulina"
  },
  {
    gender: "female",
    language: {
      codes: [
        "es",
        "es-es"
      ],
      display_name: "Español (España)",
      name: "Spanish (Castilian)"
    },
    vendor: "Nuance",
    voice_id: "Monica"
  },
  {
    gender: "female",
    language: {
      codes: [
        "sv",
        "sv-se"
      ],
      display_name: "Svenska",
      name: "Swedish"
    },
    vendor: "Nuance",
    voice_id: "Alva"
  },
  {
    gender: "female",
    language: {
      codes: [
        "th",
        "th-th"
      ],
      display_name: "ภาษาไทย",
      name: "Thai"
    },
    vendor: "Nuance",
    voice_id: "Kanya"
  }
];
class d extends HTMLElement {
  // eslint-disable-next-line no-useless-constructor
  constructor() {
    super();
  }
}
window.customElements.get("de-speakable") || window.customElements.define("de-speakable", d);
const i = {
  configVersion: "DiscoveryEdTechbooksv351R1",
  version: "3.9.1",
  domControl: null,
  ignoredClassList: null,
  promise: null,
  speechstream: null,
  speechTools: null,
  textHelpScript: !1,
  // registers the custom element
  DESpeakable: d,
  initTextHelpScript() {
    let e, s;
    if (this.promise)
      return this.promise;
    this.promise = new Promise((a, n) => {
      e = a, s = n;
    }), this.textHelpScript = document.createElement("script"), this.textHelpScript.async = !0, this.textHelpScript.onerror = (a) => {
      s(a);
    };
    const t = setInterval(() => {
      var a, n;
      (n = (a = window.speechstream) == null ? void 0 : a.speechTools) != null && n.play && (this.speechstream = window.speechstream, e(), clearInterval(t));
    }, 100);
    return this.textHelpScript.setAttribute("id", "de-tts"), this.textHelpScript.setAttribute("data-speechstream-config", this.configVersion), this.textHelpScript.setAttribute("src", `https://toolbar.speechstream.net/SpeechStream/${this.version}/speechstream.js`), document.body.appendChild(this.textHelpScript), this.promise;
  },
  async init() {
    if (await this.initTextHelpScript(), window.speechstream) {
      this.domControl = this.speechstream.domControlTools.getNewDomControl(window.document), this.speechTools = this.speechstream.speechTools, this.ignoredClassList = ["not-visible-on-device-container", "rs_skip_always", "hide", "device-error-header"];
      const e = this.ignoredClassList.map((s) => `.${s}`);
      this.domControl.addIgnoreListQuerySelector(e.join(", "));
    }
    if (window.MathJax) {
      const e = this.speechstream.mathTools.getMathSreSettings();
      e.sreSettings.domain = "mathspeak", this.speechstream.mathTools.setMathSreSettings(e);
    }
  }
};
let o = null;
const f = {
  props: {
    langOverride: {
      type: String,
      default: null
    }
  },
  emits: [
    "tts:speak-text",
    "tts:speak-element",
    "tts:play",
    "tts:pause",
    "tts:stop"
  ],
  data() {
    return {
      domControl: null,
      languageCode: null,
      loadTextToSpeech: !0,
      readableElements: [],
      readingMath: null,
      textHelpScript: null,
      speechstream: null,
      speechTools: null,
      updateCount: 1,
      voiceList: r
    };
  },
  async mounted() {
    this.loadTextToSpeech && (await i.init(), this.setLanguageCode(
      this.getDefaultlanguageCode()
    ), this.speechstream = i.speechstream, this.domControl = i.domControl, this.speechTools = i.speechTools, this.ignoredClassList = i.ignoredClassList, this.languageCode = this.languageCode ?? this.getDefaultlanguageCode(), this.setVoiceByLanguage(this.languageCode), this.setupSpeechHighlighting(), this.speechTools.setPageCompleteCallback(() => {
      this.clearMathStyles(), !(!this.readableElements.length && this !== o) && (this.readableElements.length > 0 && (this.readingMath || this.readableElements.shift(), this.speakElements(this.readableElements)), this.eventBus && this.eventBus.emit("tts:page-complete", this.readableElements), this.updateCount += 1);
    }), this.eventBus && this.eventBus.emit("tts:initialized", this));
  },
  computed: {
    isSpeaking() {
      var e;
      return this.updateCount && ((e = this.speechTools) == null ? void 0 : e.isSpeaking());
    },
    isPaused() {
      var e;
      return this.updateCount && ((e = this.speechTools) == null ? void 0 : e.isPaused());
    },
    isStopped() {
      return !this.isSpeaking && !this.isPaused;
    },
    hasReadableElements() {
      return this.readableElements.length;
    }
  },
  watch: {
    langOverride(e) {
      this.setVoiceByLanguage(e);
    }
  },
  methods: {
    clearMathStyles() {
      const e = [...document.querySelectorAll(".MathJax")];
      e.length && e.forEach((s) => {
        s.style.backgroundColor = "inherit";
      });
    },
    getDefaultlanguageCode() {
      return this.langOverride ? this.langOverride : window.initData ? window.initData.locale : document.getElementsByTagName("html")[0].getAttribute("lang");
    },
    setLanguageCode(e) {
      this.languageCode = e.toLowerCase().replace(/_/, "-");
    },
    setVoiceByLanguage(e) {
      let s = {};
      r.forEach((t) => {
        t.language.codes.forEach((a) => {
          a === e && (s = t);
        });
      }), this.setVoice(s.voice_id);
    },
    setVoice(e) {
      this.speechstream.speechTools.setVoice(e);
    },
    speakText(e) {
      o = this, this.$emit("tts:speak-text", e), this.speechstream.speechTools.speakText(e);
    },
    /**
         * Speak text in the element passed to this function.
         *
         * @param {string}      elementSelector Element to speak
         * @param {boolean}     cont            Optional parameter -- If true, continue to next element.
     */
    speakElement(e, s = !1) {
      const t = document.querySelector(e), a = t.getAttribute("data-tts-lang");
      a && this.setVoiceByLanguage(a), this.isSpeaking && this.stop(), t && (o = this, this.$emit("tts:speak-element", t), this.speechstream.speechTools.speakElement(t, s)), this.setVoiceByLanguage(
        this.getDefaultlanguageCode()
      );
    },
    /**
     * speakElements passes each item of an array of elements to speakElement
     * and waits to read the next item until all items in array have been read.
     */
    speakElements(e) {
      if (this.readableElements = e.filter(
        (a) => !this.ignoredClassList.some(
          (n) => a.parentElement.classList.contains(n)
        )
      ), !this.readableElements.length) return;
      const s = this.readableElements[0];
      this.$emit("tts:play");
      const t = s.closest(".math-formula");
      if (!t)
        this.readingMath = !1, this.speechTools.speakElement(this.readableElements[0], !1);
      else {
        this.readingMath = !0;
        const a = t.querySelector('[type="math/mml"]').getAttribute("id"), n = t.querySelector(`#${a}-Frame`);
        t.id = `${a}-Wrapper`, this.readableElements = this.readableElements.filter((c) => !c.closest(`#${a}-Wrapper`)), n.style.backgroundColor = `${l.tokens.color.teach.primary[400]}`, this.speechTools.speakById(`${a}-Wrapper`, !1);
      }
    },
    play() {
      const { commonAncestor: e } = m.selection;
      if (h.isNodeInSelector(e, ".math-formula")) {
        const t = e.closest(".MathJax");
        t.style.backgroundColor = `${l.tokens.color.teach.primary[400]}`;
      }
      !this.isSpeaking && !this.isPaused && (o = this, this.$emit("tts:play"), this.speechstream.speechTools.play(), this.updateCount += 1), (this.isSpeaking || this.isPaused) && this.pause();
    },
    pause() {
      this.$emit("tts:pause"), this.speechstream.speechTools.pause(), this.updateCount += 1;
    },
    stop() {
      this.readableElements.length && (this.readableElements = []), this.$emit("tts:stop"), this.speechstream.speechTools.stop(), this.updateCount += 1;
    },
    setupSpeechHighlighting() {
      this.speechstream.speechTools.setSentenceHighlightStyle("background-color:transparent;"), this.speechstream.speechTools.setWordHighlightStyle(
        `background-color:${l.tokens.color.teach.primary[400]};`
      );
    }
  },
  beforeUnmount() {
    const e = document.getElementById("de-tts");
    e && e.remove();
  }
};
export {
  f as default
};
